uniform float time;
uniform float progress;
uniform sampler2D uMap;
uniform vec4 resolution;
varying vec2 vUv;
varying vec3 vPosition;
float PI = 3.141592653589793238;
float hash12(vec2 p)
{
	vec3 p3  = fract(vec3(p.xyx) * .1031);
    p3 += dot(p3, p3.yzx + 33.33);
    return fract((p3.x + p3.y) * p3.z);
}
float hue2rgb(float f1, float f2, float hue) {
    if (hue < 0.0)
        hue += 1.0;
    else if (hue > 1.0)
        hue -= 1.0;
    float res;
    if ((6.0 * hue) < 1.0)
        res = f1 + (f2 - f1) * 6.0 * hue;
    else if ((2.0 * hue) < 1.0)
        res = f2;
    else if ((3.0 * hue) < 2.0)
        res = f1 + (f2 - f1) * ((2.0 / 3.0) - hue) * 6.0;
    else
        res = f1;
    return res;
}

vec3 hsl2rgb(vec3 hsl) {
    vec3 rgb;
    
    if (hsl.y == 0.0) {
        rgb = vec3(hsl.z); // Luminance
    } else {
        float f2;
        
        if (hsl.z < 0.5)
            f2 = hsl.z * (1.0 + hsl.y);
        else
            f2 = hsl.z + hsl.y - hsl.y * hsl.z;
            
        float f1 = 2.0 * hsl.z - f2;
        
        rgb.r = hue2rgb(f1, f2, hsl.x + (1.0/3.0));
        rgb.g = hue2rgb(f1, f2, hsl.x);
        rgb.b = hue2rgb(f1, f2, hsl.x - (1.0/3.0));
    }   
    return rgb;
}

vec3 hsl2rgb(float h, float s, float l) {
    return hsl2rgb(vec3(h, s, l));
}
void main()	{
	// vec2 newUV = (vUv - vec2(0.5))*resolution.zw + vec2(0.5);
	vec3 color1 = vec3(0.997, 0.307, 0.928);
	vec3 color2 = vec3(0.964, 0.969, 0.287);
	vec3 color3 = vec3(0.209, 0.740, 0.301);
	vec3 finalColor;

	float grid = 12.;
	
	vec2 currentUV = 
			vUv*grid
			+ vec2(mod(floor(vUv.y*grid),2.),0.)/2.
		;
	vec2 idd = floor(currentUV);
	float x = hash12(vec2(idd));
	finalColor = color3;
	if(x>0.66){
		finalColor = color1;
	}
	if(x<0.33){
		finalColor = color2;
	}
    float localtime = time/8. + 0.*hash12(vec2(idd.x,idd.y +1.));
	finalColor = hsl2rgb(fract(x + floor(localtime)/4.), 1., 0.55);
	vec4 c = texture2D(uMap, fract(currentUV));
	gl_FragColor = vec4(vUv,0.0,1.);
	gl_FragColor = vec4( vec3(c.rgb)*finalColor,1.);


	if(
		abs(fract(currentUV.x))<0.1 
		|| abs(fract(currentUV.y))<0.1 || abs(1.-fract(currentUV.x))<0.1 || abs(1.-fract(currentUV.y))<0.1
	) gl_FragColor = vec4(0.,0.,0.,1.);
	// gl_FragColor = c;
}